import axios from 'axios';

const api = process.env.REACT_APP_API_REMINDERS || '';

// GET and DELETE must NOT include Content-Type — the API rejects DELETE with it
const authHeaders = (token) => ({
  Authorization: `Bearer ${token}`,
});

// POST and PATCH need Content-Type
const jsonHeaders = (token) => ({
  Authorization: `Bearer ${token}`,
  'Content-Type': 'application/json',
  Accept: 'application/json',
});

const obtenerReminders = async (token) => {
  const response = await axios.get(`${api}/reminders`, {
    headers: authHeaders(token),
  });
  return response.data;
};

const obtenerReminderPorId = async (id, token) => {
  const response = await axios.get(`${api}/reminders/${id}`, {
    headers: authHeaders(token),
  });
  return response.data;
};

const crearReminder = async (registro, token) => {
  const response = await axios.post(`${api}/reminders`, registro, {
    headers: jsonHeaders(token),
  });
  // API returns { $metadata, Item: { ... } }
  return response.data?.Item ?? response.data;
};

const actualizarReminder = async (id, registro, token) => {
  const response = await axios.patch(`${api}/reminders/${id}`, registro, {
    headers: jsonHeaders(token),
  });
  return response.data?.Item ?? response.data;
};

const eliminarReminder = async (id, token) => {
  const response = await axios.delete(`${api}/reminders/${id}`, {
    headers: authHeaders(token),
  });
  return response.data;
};

const remindersService = {
  obtenerReminders,
  obtenerReminderPorId,
  crearReminder,
  actualizarReminder,
  eliminarReminder,
};

export default remindersService;
